import { TABLA_DISTRIBUCION_POR_ESPACIO } from '../../../../../config/tables'
import { TablaDistribucionEspacioPorEspacioService } from '../../../../../models/movimiento/cuadroDeMando/tabla_distribucion_por_espacio'
import { COLUMNS_DISTRIBUCION_POR_ESPACIO, COLUMNS_DISTRIBUCION_POR_ESPACIO_TO_PRINT } from './constantesDistribucionEspacioPorCereal'
import { pdfCustomToolbarGenerator } from '../../../../../models/tools/generarPdf'
import React from 'react'
import { Button } from 'react-bootstrap'

export function actualizarDatosParaMuiTable (conLink) {
  return dispatch => {
    dispatch({
      type: 'UPDATE_MUITABLE',
      newState: {
        isLoading: true
      },
      id: TABLA_DISTRIBUCION_POR_ESPACIO
    })
    const promiseTablaDistribucionPorEspacio = TablaDistribucionEspacioPorEspacioService.getDataTablaDistribucionPorEspacio()
    const promiseTablaDistribucionPorEspacioTotal = TablaDistribucionEspacioPorEspacioService.getDataTablaDistribucionPorEspacioTotal()
    Promise.all([promiseTablaDistribucionPorEspacio, promiseTablaDistribucionPorEspacioTotal]).then(callback)
    function callback (dataArray) {
      const dataCombinada = dataArray[0].filas || []
      const filaTotalArreglada = dataArray[1].filas[0]
      filaTotalArreglada['cereal'] = 'Total'
      dataCombinada.push(filaTotalArreglada)
      const customToolbar = () => <> {pdfCustomToolbarGenerator(
        'Espacio Por Cereal',
        dataCombinada,
        COLUMNS_DISTRIBUCION_POR_ESPACIO_TO_PRINT,
        'landscape')()}{conLink && <Button href='/laridae/movimiento/espacioPorCereal' class='btn btn-primary btn-lg active' role='button' aria-pressed='true'>Detalles Por Espacio</Button>}</>
      dispatch({
        type: 'UPDATE_MUITABLE',
        newState: {
          columns: COLUMNS_DISTRIBUCION_POR_ESPACIO,
          data: dataCombinada,
          title: `Espacio Por Cereal`,
          isLoading: false,
          fixed2Decimales: true,
          extraOptions: { customToolbar, pagination: false }
        },
        id: TABLA_DISTRIBUCION_POR_ESPACIO
      })
    }
  }
}
